import React from 'react';
import { childAbuseItHTML } from '../static/childAbuseIt';

const ChildAbuseIt = () => {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }} dangerouslySetInnerHTML={{ __html: childAbuseItHTML(`${process.env.PUBLIC_URL}/images/mini-logo.png`) }}></div>
  )
}

export default ChildAbuseIt;